/*
 * Close the mega menu when the pointer leaves it.
 *
 * The menu is a <details> that opens on click; this adds only the exit
 * behaviour. The short delay stops it snapping shut as the pointer crosses the
 * gap between the summary and the panel.
 */
(() => {
  const CLOSE_DELAY = 180;

  const bind = () => {
    document.querySelectorAll('.header__mega-menu-details').forEach((details) => {
      if (details.dataset.closeOnLeave) return;
      details.dataset.closeOnLeave = '1';

      let timer = null;
      const cancel = () => {
        if (timer) clearTimeout(timer);
        timer = null;
      };

      details.addEventListener('mouseleave', () => {
        cancel();
        timer = setTimeout(() => details.removeAttribute('open'), CLOSE_DELAY);
      });

      details.addEventListener('mouseenter', cancel);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
